const header = document.querySelector(".header");
if (header) {
  const links = header.querySelectorAll(".header__menu_item_has_drop");
  const drops = header.querySelectorAll(".header__drop");
  const closeSearch = header.querySelector(".header__search_clear_icon");
  const dropdown = document.querySelector('.header__dropdown');
  const dropdownContent = document.querySelectorAll('.header__dropdown_content');

  if (links && drops && closeSearch) {
    closeSearch.addEventListener("click", (e) => {
      e.preventDefault();
      inactiveDrop();
      header.classList.remove("drop_open", "drop_open_search");
    });

    // Desktop click functionality only
    links.forEach((element) => {
      element.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();

        const tab = element.getAttribute("data-tab");
        console.log('Click on tab:', tab, 'Active:', element.classList.contains("active"));

        if (tab) {
          if (tab === "search") {
            // Special handling for search
            if (element.classList.contains("active")) {
              // Close search
              console.log('Closing search');
              inactiveDrop();
              element.classList.remove("active");
              header.classList.remove("drop_open", "drop_open_search");
            } else {
              // Open search
              console.log('Opening search');
              activeDrop(tab);
              element.classList.add("active");
              header.classList.add("drop_open", "drop_open_search");
              // Don't call showDefaultSuggestions here - use the Liquid template HTML
            }
          } else {
            // Regular menu handling
            if (element.classList.contains("active")) {
              console.log('Closing dropdown for tab:', tab);
              inactiveDrop();
              element.classList.remove("active");
              header.classList.remove("drop_open", "drop_open_search");
            } else {
              console.log('Opening dropdown for tab:', tab);
              activeDrop(tab);
              element.classList.add("active");
              header.classList.add("drop_open");
            }
          }
        }
      });
    });

    // Hide dropdown when mouse leaves (except for search)
    if (dropdown) {
      dropdown.addEventListener('mouseleave', function () {
        // Don't hide if search is active
        if (!header.classList.contains('drop_open_search')) {
          this.classList.remove('active');
          dropdownContent.forEach(c => c.classList.remove('active'));
        }
      });
    }

    drops.forEach((drop) => {
      const items = drop.querySelectorAll(".header__drop_item");
      const blocks = drop.querySelectorAll(".header__drop_block");
      if (items && blocks) {
        items.forEach((element) => {
          element.addEventListener("click", (e) => {
            e.preventDefault();
            const tab = element.getAttribute("data-tab");
            if (tab) {
              // Если элемент уже активен, переходим по ссылке
              if (element.classList.contains("active")) {
                const link = element.querySelector("a.header__drop_item_text");
                if (link && link.href) {
                  window.location.href = link.href;
                  return;
                }
              }
              // Иначе активируем блок
              activeDropBlock(tab);
              element.classList.add("active");
            }
          });
        });

        function activeDropBlock(tab) {
          blocks.forEach((element) => {
            const attr = element.getAttribute("data-tab");
            if (attr == tab) {
              inactiveDropBlock();
              element.classList.add("active");
            }
          });
        }

        function inactiveDropBlock() {
          items.forEach((element) => {
            element.classList.remove("active");
          });
          blocks.forEach((element) => {
            element.classList.remove("active");
          });
        }
      }
    });

    function activeDrop(tab) {
      console.log('activeDrop called with tab:', tab);

      // First close all dropdowns
      inactiveDrop();

      // Then open the specific one
      drops.forEach((element) => {
        const attr = element.getAttribute("data-tab");
        console.log('Checking drop element with tab:', attr);
        if (attr == tab) {
          console.log('Opening dropdown for tab:', tab);
          element.classList.add("active");
        }
      });
    }

    function inactiveDrop() {
      console.log('inactiveDrop called');
      links.forEach((element) => {
        element.classList.remove("active");
      });
      drops.forEach((element) => {
        element.classList.remove("active");
      });
    }

    // Close dropdown when clicking outside
    document.addEventListener('click', (e) => {
      // Check if click is outside header and dropdown areas
      const isClickInsideHeader = header.contains(e.target);
      const isClickInsideDrops = Array.from(drops).some(drop => drop.contains(e.target));

      if (!isClickInsideHeader && !isClickInsideDrops) {
        inactiveDrop();
        header.classList.remove("drop_open", "drop_open_search");
      }
    });
  }

  // Search functionality
  const searchInput = document.querySelector('.header__search_field input');
  const searchClear = document.querySelector('.header__search_clear');
  const searchClearText = document.querySelector('.header__search_clear_text');
  const searchClearIcon = document.querySelector('.header__search_clear_icon');
  const searchDropdown = document.querySelector('.header__drop[data-tab="search"]');
  const searchResults = document.querySelector('.header__drop_results');
  const searchProducts = document.querySelector('.header__drop[data-tab="search"] .header__drop_products');

  // Mobile search containers
  const mobileSearchContent = document.querySelector('.header_mob__search_content');
  const mobileSearchResults = document.querySelector('.header_mob__search_items');
  const mobileSearchProducts = document.querySelector('.header_mob__search_products');

  // Save original HTML on page load (save entire content blocks to preserve all suggestions)
  let originalSearchResultsHTML = searchResults ? searchResults.innerHTML : '';
  let originalSearchProductsHTML = searchProducts ? searchProducts.innerHTML : '';
  let originalMobileSearchContentHTML = mobileSearchContent ? mobileSearchContent.innerHTML : '';


  if (searchInput && searchDropdown) {
    let searchTimeout;

    // Show search dropdown on input focus
    searchInput.addEventListener('focus', function () {
      if (dropdown) dropdown.classList.add('active');
      if (searchDropdown) searchDropdown.classList.add('active');
    });

    // Search functionality
    searchInput.addEventListener('input', function () {
      const query = this.value.trim();

      // Clear previous timeout
      clearTimeout(searchTimeout);

      if (query.length === 0) {
        // Show default suggestions
        if (window.showDefaultSuggestions) {
          window.showDefaultSuggestions();
        }
        return;
      }

      // Debounce search
      searchTimeout = setTimeout(() => {
        if (window.performSearch) {
          window.performSearch(query);
        }
      }, 300);
    });

    // Clear search text (only clears input, doesn't close search)
    if (searchClearText) {
      searchClearText.addEventListener('click', function (e) {
        e.preventDefault();
        searchInput.value = '';
        // Show default suggestions when cleared
        if (window.showDefaultSuggestions) {
          window.showDefaultSuggestions();
        }
        searchInput.focus();
      });
    }

    // Clear search icon (closes search completely)
    if (searchClearIcon) {
      searchClearIcon.addEventListener('click', function (e) {
        e.preventDefault();
        searchInput.value = '';
        // Close search dropdown
        if (dropdown) dropdown.classList.remove('active');
        if (searchDropdown) searchDropdown.classList.remove('active');
        // Remove search active state
        header.classList.remove('drop_open', 'drop_open_search');
        // Remove active class from search button
        const searchButton = document.querySelector('[data-tab="search"]');
        if (searchButton) searchButton.classList.remove('active');
        // Clear all dropdown content
        dropdownContent.forEach(c => c.classList.remove('active'));
      });
    }

    // Hide search on click outside (except when search is active)
    document.addEventListener('click', function (e) {
      if (!searchInput.contains(e.target) && !searchDropdown.contains(e.target)) {
        // Don't hide if search is active
        if (!header.classList.contains('drop_open_search')) {
          if (dropdown) dropdown.classList.remove('active');
          if (searchDropdown) searchDropdown.classList.remove('active');
        }
      }
    });
  }

  // Search functions (moved to global scope for mobile access)
  window.performSearch = function (query) {
    if (query.length < 2) return;

    // Show loading state
    showLoadingState();

    // Perform search via Shopify API
    fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=2`)
      .then(response => response.json())
      .then(data => {
        if (window.displaySearchResults) {
          window.displaySearchResults(query, data);
        }
      })
      .catch(error => {
        console.error('Search error:', error);
        if (window.showDefaultSuggestions) {
          window.showDefaultSuggestions();
        }
      });
  };

  window.displaySearchResults = function (query, data) {
    const products = data.resources.results.products || [];

    // Update desktop search results
    if (searchResults) {
      searchResults.innerHTML = `
        <div class="header__drop_result">
          <h3 class="header__drop_result_title">Suggestions</h3>
          <div class="header__drop_result_items">
            ${products.map(product => `
              <a href="${product.url}" class="header__drop_result_item">
                <span>${highlightQuery(product.title, query)}</span>
              </a>
            `).join('')}
          </div>
        </div>
        <div class="header__drop_result">
          <h3 class="header__drop_result_title">Recommended Topics</h3>
          <div class="header__drop_result_items">
            <a href="#" class="header__drop_result_item">Hormone Health (<span>${query}</span>/HRT)</a>
            <a href="#" class="header__drop_result_item">Peptide Therapy</a>
            <a href="#" class="header__drop_result_item"><span>${query}</span> Support Stacks</a>
          </div>
        </div>
        <a href="https://aspnlabs.org/pages/shop-page" class="button button_brown_dark header__drop_all">Explore All Results</a>
      `;
    }

    // Update mobile search results
    if (mobileSearchResults) {
      mobileSearchResults.innerHTML = `
        ${products.map(product => `
          <a href="${product.url}" class="header_mob__search_item">
            <span>${highlightQuery(product.title, query)}</span>
          </a>
        `).join('')}
      `;
    }

    // Update desktop products
    if (searchProducts) {
      searchProducts.innerHTML = products.map(product => {
        const imageUrl = product.image ? product.image : '/cdn/shop/files/product-placeholder.png';
        return `
        <a href="${product.url}" class="header__drop_product product">
          <div class="product__thumb">
            ${product.tags && product.tags.includes('best-seller') ? `
              <div class="product__badge product__badge_best">
                <span>Best Seller</span>
                <div class="product__badge_background">
                  <img src="/cdn/shop/files/badge-background.png" alt="Badge">
                </div>
              </div>
            ` : ''}
            <div class="product__image">
              <img src="${imageUrl}" alt="${product.title}">
            </div>
          </div>
          <div class="product__content">
            <div class="product__head">
              <h3 class="product__title">${product.title}</h3>
              <p class="product__text">${product.body_html ? product.body_html.replace(/<[^>]*>/g, '').substring(0, 50) + '...' : ''}</p>
            </div>
            <p class="product__price">${product.price ? formatPrice(product.price) : ''}</p>
          </div>
        </a>
      `}).join('');
    }

    // Update mobile products
    if (mobileSearchProducts) {
      mobileSearchProducts.innerHTML = products.map(product => {
        const imageUrl = product.image ? product.image : '/cdn/shop/files/product-placeholder.png';
        return `
        <a href="${product.url}" class="header_mob__search_product">
          <div class="header_mob__search_product_image">
            <img src="${imageUrl}" alt="${product.title}">
          </div>
          <div class="header_mob__search_product_content">
            <h3 class="header_mob__search_product_title">${product.title}</h3>
            <p class="header_mob__search_product_text">${product.price ? formatPrice(product.price) : ''}</p>
          </div>
        </a>
      `}).join('');
    }
  };

  window.showDefaultSuggestions = function () {
    // Restore original HTML from page load
    if (searchResults && originalSearchResultsHTML) {
      searchResults.innerHTML = originalSearchResultsHTML;
    }

    if (searchProducts && originalSearchProductsHTML) {
      searchProducts.innerHTML = originalSearchProductsHTML;
    }

    if (mobileSearchContent && originalMobileSearchContentHTML) {
      mobileSearchContent.innerHTML = originalMobileSearchContentHTML;
    }
  };

  function showLoadingState() {
    if (searchResults) {
      searchResults.innerHTML = `
        <div class="header__drop_result">
          <h3 class="header__drop_result_title">Searching...</h3>
          <div class="header__drop_result_items">
            <div class="header__drop_result_item">Please wait...</div>
          </div>
        </div>
      `;
    }
  }

  function highlightQuery(text, query) {
    if (!query) return text;
    const regex = new RegExp(`(${query})`, 'gi');
    return text.replace(regex, '<span>$1</span>');
  }

  function formatPrice(price) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(price);
  }
}

const el8 = document.querySelector(".el8");
if (el8) {
  const blocks = el8.querySelectorAll(".el8__block");
  const indicators = el8.querySelectorAll(".el8__indicator");

  let currentBlock = 0;
  let isScrolling = false;
  let sectionInCenter = false;
  let isSnapping = false;

  // Функция для активации блока
  function activateBlock(index) {
    if (index < 0 || index >= blocks.length) {
      console.log('Invalid block index:', index);
      return;
    }

    console.log('Activating block:', index);

    // Удаляем active класс у всех блоков и индикаторов
    blocks.forEach(block => block.classList.remove("active"));
    indicators.forEach(indicator => indicator.classList.remove("active"));

    // Добавляем active класс текущему блоку и индикатору
    blocks[index].classList.add("active");
    indicators[index].classList.add("active");

    currentBlock = index;
    console.log('Block activated:', index);
  }

  // Функция проверки, занимает ли секция полный экран
  function isSectionFullscreen() {
    const rect = el8.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    // Добавляем небольшой допуск в 50px для учёта возможных погрешностей
    const tolerance = 50;

    // Секция занимает полный экран, если её верх близок к 0 или выше,
    // а низ близок к высоте окна или ниже
    const isFullscreen = rect.top <= tolerance && rect.bottom >= (windowHeight - tolerance);

    console.log('isSectionFullscreen check:', {
      rectTop: rect.top,
      rectBottom: rect.bottom,
      windowHeight: windowHeight,
      tolerance: tolerance,
      result: isFullscreen
    });

    return isFullscreen;
  }

  // Функция для плавного скролла к секции
  function snapToSection() {
    if (isSnapping) return;

    const rect = el8.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    // Если пользователь на последнем блоке и секция начала уходить вниз - не snap
    if (currentBlock === blocks.length - 1 && rect.top < 0) {
      console.log('On last block and scrolling away - no snap');
      return;
    }

    // Если пользователь на первом блоке и секция начала уходить вверх - не snap
    if (currentBlock === 0 && rect.top > 0) {
      console.log('On first block and scrolling away - no snap');
      return;
    }

    // Если секция занимает больше 30% экрана, но не полностью - "притягиваем" её
    const visiblePercentage = Math.min(
      (windowHeight - Math.max(0, rect.top)) / windowHeight,
      (Math.min(windowHeight, rect.bottom) - Math.max(0, rect.top)) / rect.height
    );

    console.log('Snap check - visible percentage:', visiblePercentage);

    if (visiblePercentage > 0.3 && !isSectionFullscreen()) {
      console.log('Snapping to section');
      isSnapping = true;

      el8.scrollIntoView({ behavior: 'smooth', block: 'start' });

      setTimeout(() => {
        isSnapping = false;
      }, 1000);
    }
  }

  // Обработчик скролла на body
  function handleBodyScroll(e) {
    // Если происходит snap анимация, не обрабатываем скролл
    if (isSnapping) {
      e.preventDefault();
      return;
    }

    // Проверяем, занимает ли секция полный экран
    sectionInCenter = isSectionFullscreen();

    const rect = el8.getBoundingClientRect();
    console.log('Scroll event:', {
      sectionInFullscreen: sectionInCenter,
      rectTop: rect.top,
      rectBottom: rect.bottom,
      windowHeight: window.innerHeight,
      currentBlock: currentBlock,
      isScrolling: isScrolling
    });

    if (!sectionInCenter) {
      console.log('Section not in fullscreen, allowing normal scroll');
      // Проверяем, нужно ли "притянуть" секцию
      snapToSection();
      return; // Не перехватываем скролл, если секция не занимает весь экран
    }

    if (isScrolling) {
      console.log('Already scrolling, preventing event');
      e.preventDefault();
      return;
    }

    const delta = e.deltaY || e.detail || e.wheelDelta;
    console.log('Delta:', delta);

    // Определяем направление скролла
    if (delta > 0 && currentBlock < blocks.length - 1) {
      // Скролл вниз - переход к следующему блоку
      console.log('Scrolling down to block:', currentBlock + 1);
      e.preventDefault();
      isScrolling = true;
      activateBlock(currentBlock + 1);

      setTimeout(() => {
        isScrolling = false;
      }, 800);
    } else if (delta < 0 && currentBlock > 0) {
      // Скролл вверх - переход к предыдущему блоку
      console.log('Scrolling up to block:', currentBlock - 1);
      e.preventDefault();
      isScrolling = true;
      activateBlock(currentBlock - 1);

      setTimeout(() => {
        isScrolling = false;
      }, 800);
    } else if (delta > 0 && currentBlock === blocks.length - 1) {
      // На последнем блоке и скроллим вниз - разрешаем обычный скролл
      console.log('At last block, scrolling down - allowing normal scroll to continue');
      // Не вызываем e.preventDefault(), позволяем странице скроллиться дальше
    } else if (delta < 0 && currentBlock === 0) {
      // На первом блоке и скроллим вверх - разрешаем обычный скролл
      console.log('At first block, scrolling up - allowing normal scroll to continue');
      // Не вызываем e.preventDefault(), позволяем странице скроллиться дальше
    } else {
      console.log('At boundary, no action taken');
    }
  }

  // Добавляем обработчик скролла на body
  document.body.addEventListener("wheel", handleBodyScroll, { passive: false });
  document.body.addEventListener("DOMMouseScroll", handleBodyScroll, { passive: false });

  // Обработчик клика по индикаторам
  indicators.forEach((indicator) => {
    indicator.addEventListener("click", (e) => {
      e.preventDefault();
      const blockIndex = parseInt(indicator.getAttribute("data-block"));
      if (!isNaN(blockIndex) && blockIndex !== currentBlock) {
        activateBlock(blockIndex);
      }
    });
  });

  // Touch события для мобильных устройств
  let touchStartY = 0;
  let touchEndY = 0;

  document.body.addEventListener("touchstart", (e) => {
    if (isSectionFullscreen()) {
      touchStartY = e.changedTouches[0].screenY;
    }
  }, { passive: true });

  document.body.addEventListener("touchend", (e) => {
    if (isSectionFullscreen()) {
      touchEndY = e.changedTouches[0].screenY;
      handleTouchScroll();
    }
  }, { passive: true });

  function handleTouchScroll() {
    if (isScrolling) return;

    const swipeThreshold = 50;
    const diff = touchStartY - touchEndY;

    if (Math.abs(diff) > swipeThreshold) {
      if (diff > 0 && currentBlock < blocks.length - 1) {
        // Свайп вверх - следующий блок
        isScrolling = true;
        activateBlock(currentBlock + 1);
        setTimeout(() => {
          isScrolling = false;
        }, 800);
      } else if (diff < 0 && currentBlock > 0) {
        // Свайп вниз - предыдущий блок
        isScrolling = true;
        activateBlock(currentBlock - 1);
        setTimeout(() => {
          isScrolling = false;
        }, 800);
      }
    }
  }

  // Инициализация - активируем первый блок
  activateBlock(0);
}

const el26 = document.querySelector(".el26");
if (el26) {
  const slider = el26.querySelector(".el26__slider");
  if (slider) {
    const swiper = new Swiper(slider, {
      slidesPerView: 1.3,
      spaceBetween: 8,
      breakpoints: {
        550: {
          slidesPerView: 2.2,
        },
      },
    });
  }
}

const headerMob = document.querySelector(".header_mob");
if (headerMob) {
  const dropdowns = headerMob.querySelectorAll(".header_mob__item");
  if (dropdowns) {
    dropdowns.forEach((element) => {
      const head = element.querySelector(".header_mob__item_head");
      head.addEventListener("click", (e) => {
        e.preventDefault();
        element.classList.toggle("open");
      });
    });
  }
  const burger = headerMob.querySelector(".header_mob__burger");
  const mobileMenu = headerMob.querySelector(".header_mob__nav");

  if (burger) {
    burger.addEventListener("click", (e) => {
      e.preventDefault();
      headerMob.classList.toggle("open");
      // Toggle drop_open class on desktop header for consistent styling
      if (header) {
        header.classList.toggle("drop_open");
      }
    });
  }

  // Mobile menu functionality
  if (mobileMenu) {
    const mobileButton = document.querySelector('.header__mobile_button');
    if (mobileButton) {
      mobileButton.addEventListener('click', function () {
        this.classList.toggle('active');
        mobileMenu.classList.toggle('active');
      });
    }
  }
  const searchButton = headerMob.querySelector(".header_mob__tool_search");
  const searchClose = headerMob.querySelector(".header_mob__search_close");
  const searchBlock = headerMob.querySelector(".header_mob__search");
  const mobileSearchInput = headerMob.querySelector(".header_mob__search_form input");
  const mobileSearchClear = headerMob.querySelector(".header_mob__search_clear");


  if (searchButton && searchClose && searchBlock) {
    searchButton.addEventListener("click", (e) => {
      e.preventDefault();
      searchBlock.classList.add("open");
      if (mobileSearchInput) {
        mobileSearchInput.focus();
      }
    });
    searchClose.addEventListener("click", (e) => {
      e.preventDefault();
      searchBlock.classList.remove("open");
    });
  }

  if (mobileSearchClear) {
    mobileSearchClear.addEventListener("click", function () {
      if (mobileSearchInput) {
        mobileSearchInput.value = '';
        if (window.showDefaultSuggestions) {
          window.showDefaultSuggestions();
        }
      }
    });
  }

  // Mobile search input
  if (mobileSearchInput) {
    let mobileSearchTimeout;

    mobileSearchInput.addEventListener('input', function () {
      const query = this.value.trim();

      clearTimeout(mobileSearchTimeout);

      if (query.length === 0) {
        if (window.showDefaultSuggestions) {
          window.showDefaultSuggestions();
        }
        return;
      }

      mobileSearchTimeout = setTimeout(() => {
        if (window.performSearch) {
          window.performSearch(query);
        }
      }, 300);
    });
  }
}


const el12 = document.querySelector(".el12");
if (el12) {
  const slider = el12.querySelector(".el12__items");
  if (slider) {
    const slidesCount = slider.querySelectorAll(".swiper-slide").length;
    const maxSlidesDesktop = Math.max(slidesCount, 4);
    const isMobile = () => window.innerWidth < 768;

    const swiper = new Swiper(slider, {
      slidesPerView: 1,
      allowTouchMove: !isMobile(),
      breakpoints: {
        500: {
          slidesPerView: 2,
        },
        768: {
          slidesPerView: 3,
        },
        1024: {
          slidesPerView: maxSlidesDesktop,
        },
      },
    });

    // Scroll-driven animation for mobile
    if (isMobile()) {
      // Wrap el12 in scroll container
      const scrollContainer = document.createElement("div");
      scrollContainer.className = "el12-scroll-container";
      // Height = 100vh per slide
      scrollContainer.style.height = `${slidesCount * 100}vh`;
      el12.parentNode.insertBefore(scrollContainer, el12);
      scrollContainer.appendChild(el12);

      // Add pagination dots
      const pagination = document.createElement("div");
      pagination.className = "el12__pagination";
      for (let i = 0; i < slidesCount; i++) {
        const dot = document.createElement("span");
        dot.className = "el12__pagination_dot" + (i === 0 ? " active" : "");
        pagination.appendChild(dot);
      }
      el12.querySelector(".el12__wrapper").appendChild(pagination);
      const dots = pagination.querySelectorAll(".el12__pagination_dot");

      // Scroll handler
      const handleScroll = () => {
        const containerRect = scrollContainer.getBoundingClientRect();
        const scrollProgress = -containerRect.top / (scrollContainer.offsetHeight - window.innerHeight);
        const clampedProgress = Math.max(0, Math.min(1, scrollProgress));
        const targetSlide = Math.min(
          Math.floor(clampedProgress * slidesCount),
          slidesCount - 1
        );

        if (swiper.activeIndex !== targetSlide) {
          swiper.slideTo(targetSlide);
          dots.forEach((dot, i) => {
            dot.classList.toggle("active", i === targetSlide);
          });
        }
      };

      window.addEventListener("scroll", handleScroll, { passive: true });

      // Handle resize
      window.addEventListener("resize", () => {
        if (!isMobile()) {
          // Remove scroll container on desktop
          scrollContainer.parentNode.insertBefore(el12, scrollContainer);
          scrollContainer.remove();
          pagination.remove();
          swiper.allowTouchMove = true;
          window.removeEventListener("scroll", handleScroll);
        }
      });
    }
  }
}

const el13 = document.querySelector(".el13");
if (el13) {
  const drops = el13.querySelectorAll(".el13__tab_drop");
  if (drops) {
    drops.forEach((drop) => {
      const head = drop.querySelector(".el13__tab_drop_head");
      if (head) {
        head.addEventListener("click", (e) => {
          e.preventDefault();
          drop.classList.toggle("active");
        });
      }
    });
  }
  const navs = el13.querySelectorAll(".el13__nav");
  const tabs = el13.querySelectorAll(".el13__tabs");
  if (navs && tabs) {
    navs.forEach((nav) => {
      nav.addEventListener("click", (e) => {
        e.preventDefault();
        const attr = nav.getAttribute("data-tab");
        if (attr) {
          activeNavBlock(attr);
        }
      });
    });

    function activeNavBlock(tab) {
      navs.forEach((nav) => {
        const attr = nav.getAttribute("data-tab");
        if (attr == tab) {
          inactiveNavs();
          nav.classList.add("active");
        }
      });
      tabs.forEach((element) => {
        const attr = element.getAttribute("data-tab");
        if (attr == tab) {
          inactiveBlocks();
          element.classList.add("active");
        }
      });
    }
    function inactiveNavs() {
      navs.forEach((nav) => nav.classList.remove("active"));
    }
    function inactiveBlocks() {
      tabs.forEach((tab) => tab.classList.remove("active"));
    }
  }
}

const el14 = document.querySelector(".el15");

if (el14) {
  const dropButton = el14.querySelector(".el15__drop_head_change_select");
  const contents = el14.querySelectorAll(".el15__drop_content");

  if (dropButton && contents) {
    dropButton.addEventListener("change", (e) => {
      const value = e.target.value;
      activeBlock(value);
    });

    function activeBlock(tab) {
      const currentActive = el14.querySelector(".el15__drop_content.active");
      const newActive = el14.querySelector(`.el15__drop_content[data-tab="${tab}"]`);

      if (currentActive && newActive && currentActive !== newActive) {
        // Фиксируем высоту контейнера для предотвращения скачков
        const containerHeight = el14.offsetHeight;
        el14.style.height = containerHeight + 'px';

        // Подготовка нового блока (позиционируем абсолютно, чтобы он не влиял на высоту)
        newActive.style.position = "absolute";
        newActive.style.bottom = "0";
        newActive.style.left = "0";
        newActive.style.width = "100%";
        newActive.style.transition = "none";
        newActive.style.transform = "translateX(-100%)";
        newActive.style.opacity = "0";
        newActive.classList.add("active");

        // Анимация скрытия текущего активного блока (вправо + прозрачность)
        currentActive.style.transition = "transform 0.3s ease-out, opacity 0.3s ease-out";
        currentActive.style.transform = "translateX(100%)";
        currentActive.style.opacity = "0";

        // Небольшая задержка перед анимацией появления нового блока
        setTimeout(() => {
          newActive.style.transition = "transform 0.3s ease-out, opacity 0.3s ease-out";
          newActive.style.transform = "translateX(0)";
          newActive.style.opacity = "1";
        }, 50);

        // После завершения анимации очищаем стили и восстанавливаем высоту
        setTimeout(() => {
          currentActive.classList.remove("active");
          currentActive.style.transform = "";
          currentActive.style.opacity = "";
          currentActive.style.transition = "";

          // Возвращаем новый блок в нормальное положение
          newActive.style.position = "";
          newActive.style.top = "";
          newActive.style.left = "";
          newActive.style.width = "";
          newActive.style.transform = "";
          newActive.style.opacity = "";
          newActive.style.transition = "";

          // Убираем фиксированную высоту
          el14.style.height = "";
        }, 350);

      } else if (newActive && !currentActive) {
        // Если нет активного блока, просто показываем новый с анимацией
        newActive.style.transition = "none";
        newActive.style.transform = "translateX(-100%)";
        newActive.style.opacity = "0";
        newActive.classList.add("active");

        setTimeout(() => {
          newActive.style.transition = "transform 0.3s ease-out, opacity 0.3s ease-out";
          newActive.style.transform = "translateX(0)";
          newActive.style.opacity = "1";
        }, 50);

        // Очищаем стили после анимации
        setTimeout(() => {
          newActive.style.transform = "";
          newActive.style.opacity = "";
          newActive.style.transition = "";
        }, 350);
      }
    }

    function inactiveBlocks() {
      contents.forEach((content) => {
        content.classList.remove("active");
        content.style.transform = "";
        content.style.opacity = "";
        content.style.transition = "";
      });
    }
  }
}

const el17 = document.querySelector(".el17");
if (el17) {
  const slider = el17.querySelector(".el17__slider");
  if (slider) {
    const swiper = new Swiper(slider, {
      slidesPerView: 1,
      navigation: {
        prevEl: el17.querySelector(".el17__nav_left"),
        nextEl: el17.querySelector(".el17__nav_right"),
      },
    });
  }
}

const el19 = document.querySelector(".el19");
if (el19) {
  const slider = el19.querySelector(".el19__slider");
  if (slider) {
    const swiper = new Swiper(slider, {
      slidesPerView: 1.2,
      centeredSlides: true,
      loop: true,
      spaceBetween: 16,
      navigation: {
        prevEl: el19.querySelector(".el19__nav_left"),
        nextEl: el19.querySelector(".el19__nav_right"),
      },
      breakpoints: {
        768: {
          slidesPerView: 1.1,
        },
        1024: {
          slidesPerView: 1.44,
        },
      },
    });
  }
}

const el20 = document.querySelector(".el20");
if (el20) {
  const items = el20.querySelectorAll(".el20__item");
  let isAnimating = false;

  items.forEach((item) => {
    const content = item.querySelector('.el20__item_content');
    const body = item.querySelector('.el20__item_body');

    if (content) {
      content.style.height = '0px';
      content.style.overflow = 'hidden';
      content.style.transition = 'none';
    }

    if (body) {
      body.style.opacity = '0';
      body.style.transform = 'translateY(-10px)';
      body.style.transition = 'none';
    }
  });

  items.forEach((item) => {
    const head = item.querySelector(".el20__item_head");
    if (head) {
      head.addEventListener("click", (e) => {
        e.preventDefault();
        if (isAnimating) return;

        const isActive = item.classList.contains('active');

        closeAllItems(item);

        if (!isActive) {
          openItem(item);
        } else {
          closeItem(item);
        }
      });
    }
  });

  function closeAllItems(exceptItem = null) {
    items.forEach((item) => {
      if (item !== exceptItem && item.classList.contains('active')) {
        closeItem(item);
      }
    });
  }

  function openItem(item) {
    isAnimating = true;

    const content = item.querySelector('.el20__item_content');
    const body = item.querySelector('.el20__item_body');

    if (content) {
      content.style.height = 'auto';
      const fullHeight = content.scrollHeight;
      content.style.height = '0px';

      item.classList.add('active');

      requestAnimationFrame(() => {
        animateHeight(content, 0, fullHeight, 400, () => {
          content.style.height = 'auto';

          if (body) {
            fadeIn(body, 0, () => {
              isAnimating = false;
            });
          } else {
            isAnimating = false;
          }
        });
      });
    } else {
      item.classList.add('active');
      isAnimating = false;
    }
  }

  function closeItem(item) {
    isAnimating = true;

    const content = item.querySelector('.el20__item_content');
    const body = item.querySelector('.el20__item_body');

    if (content) {
      const currentHeight = content.scrollHeight;

      if (body) {
        fadeOut(body, 0, () => {
          animateHeight(content, currentHeight, 0, 300, () => {
            item.classList.remove('active');
            isAnimating = false;
          });
        });
      } else {
        animateHeight(content, currentHeight, 0, 300, () => {
          item.classList.remove('active');
          isAnimating = false;
        });
      }
    } else {
      item.classList.remove('active');
      isAnimating = false;
    }
  }

  function animateHeight(element, startHeight, endHeight, duration, callback) {
    const startTime = performance.now();

    element.style.height = startHeight + 'px';
    element.style.overflow = 'hidden';

    const animate = (currentTime) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);

      const easeProgress = 1 - Math.pow(1 - progress, 3);

      const currentHeight = startHeight + (endHeight - startHeight) * easeProgress;
      element.style.height = currentHeight + 'px';

      if (progress < 1) {
        requestAnimationFrame(animate);
      } else {
        callback && callback();
      }
    };

    requestAnimationFrame(animate);
  }

  function fadeIn(element, delay = 0, callback) {
    setTimeout(() => {
      element.style.transition = 'opacity 240ms ease, transform 240ms ease';
      requestAnimationFrame(() => {
        element.style.opacity = '1';
        element.style.transform = 'translateY(0)';
      });
      callback && setTimeout(callback, 240);
    }, delay);
  }

  function fadeOut(element, delay = 0, callback) {
    setTimeout(() => {
      element.style.transition = 'opacity 160ms ease, transform 160ms ease';
      element.style.opacity = '0';
      element.style.transform = 'translateY(-10px)';
      callback && setTimeout(callback, 160);
    }, delay);
  }

  // Опциональная функция для плавной смены иконки/индикатора в head
  function animateIndicator(head, isOpening) {
    const indicator = head.querySelector('.el20__item_indicator');
    if (indicator) {
      indicator.style.transition = 'transform 300ms ease';
      indicator.style.transform = isOpening ? 'rotate(180deg)' : 'rotate(0deg)';
    }
  }
}

const el22 = document.querySelector(".el22");
if (el22) {
  const slider = el22.querySelector(".el22__slider");
  if (slider) {
    const swiper = new Swiper(slider, {
      slidesPerView: 1.01,
      spaceBetween: 16,
      breakpoints: {
        500: {
          slidesPerView: 1.7,
        },
        768: {
          slidesPerView: 2.5,
        },
        1280: {
          slidesPerView: 3.01,
        },
      },
      pagination: {
        el: document.querySelector(".el22__dots"),
        clickable: true,
      },
      navigation: {
        prevEl: document.querySelector(".el22__nav_left"),
        nextEl: document.querySelector(".el22__nav_right"),
      }
    });
  }
}

const el27 = document.querySelector(".el27");
if (el27) {
  const slider = el27.querySelector(".el27__slider");
  if (slider) {
    const swiper = new Swiper(slider, {
      slidesPerView: 1.01,
      spaceBetween: 16,
      breakpoints: {
        500: {
          slidesPerView: 1.5,
        },
        768: {
          slidesPerView: 1.1,
        },
        1024: {
          slidesPerView: 1.3,
        },
        1280: {
          slidesPerView: 1.8,
        },
      },
      pagination: {
        el: el27.querySelector(".el27__dots"),
        clickable: true,
      },
    });

    // Вешаем слушатели на ВСЕ левые кнопки
    document.querySelectorAll(".el27__nav_left").forEach(btn => {
      btn.addEventListener("click", () => {
        swiper.slidePrev();
      });
    });

    // Вешаем слушатели на ВСЕ правые кнопки
    document.querySelectorAll(".el27__nav_right").forEach(btn => {
      btn.addEventListener("click", () => {
        swiper.slideNext();
      });
    });
  }
}

const el28 = document.querySelector(".el28");
if (el28) {
  const slider = el28.querySelector(".el28__slider");
  if (slider) {
    const swiper = new Swiper(slider, {
      slidesPerView: 1.02,
      spaceBetween: 16,
      breakpoints: {
        500: {
          slidesPerView: 1.5,
        },
        768: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 3,
        },
      },
      navigation: {
        prevEl: el28.querySelector(".el28__nav_left"),
        nextEl: el28.querySelector(".el28__nav_right"),
      },
      pagination: {
        el: el28.querySelector(".el28__dots"),
        clickable: true,
      },
    });
  }
}

const el23 = document.querySelector(".el23");
const viewportWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

if (el23) {
  const items = el23.querySelectorAll(".el23__item");
  let isAnimating = false;

  items.forEach((element, index) => {
    element.style = `z-index: ${index + 1}`;
    const drop = element.querySelector('.el23__item_drop');
    if (viewportWidth <= 768) {
      drop.style.height = '37px';
      drop.style.maxHeight = '37px';
    } else {
      drop.style.height = '44px';
      drop.style.maxHeight = '44px';
    }

    const content = element.querySelector('.el23__item_content');
    const block = element.querySelector('.el23__item_block');
    const description = element.querySelector('.el23__item_description');
    const title = element.querySelector('.el23__item_title');

    content.style.opacity = '0';
    content.style.transform = 'translateY(-10px)';
    block.style.opacity = '0';
    block.style.transform = 'translateY(-10px)';

    if (description && title) {
      const titleHeight = title.offsetHeight;
      description.style.top = (titleHeight + 30) + 'px';
      description.style.opacity = '0';
      description.style.transform = 'translateY(-10px)';
    }

    const button = element.querySelector('.el23__item_button');
    button.style.opacity = '0';
    button.style.visibility = 'hidden';
    button.style.transition = 'opacity 300ms ease, visibility 300ms ease';
    button.style.pointerEvents = 'none';

    button.addEventListener('click', (e) => {
      e.stopPropagation();
    });

    element.addEventListener('mousemove', (e) => {
      if (element.classList.contains('open')) {
        const rect = element.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;

        const maxX = element.offsetWidth - button.offsetWidth;
        const maxY = element.offsetHeight - button.offsetHeight;

        const offset = 75;
        const targetX = Math.max(0, Math.min(maxX, x - button.offsetWidth / 2 + offset));
        const targetY = Math.max(0, Math.min(maxY, y - 15));

        button.style.left = targetX + 'px';
        button.style.top = targetY + 'px';
      }
    });
  });

  items.forEach((element) => {
    element.addEventListener("mouseenter", () => {
      if (isAnimating) return;

      const isOpen = element.classList.contains('open');
      if (!isOpen) {
        inactiveItem();
        openItem(element);
      }
    });
  });

  // Initialize open items
  items.forEach((element) => {
    if (element.classList.contains('open')) {
      const drop = element.querySelector('.el23__item_drop');
      const content = element.querySelector('.el23__item_content');
      const block = element.querySelector('.el23__item_block');
      const description = element.querySelector('.el23__item_description');
      const title = element.querySelector('.el23__item_title');
      const button = element.querySelector('.el23__item_button');

      if (description && title) {
        const titleHeight = title.offsetHeight;
        description.style.top = (titleHeight + 20) + 'px';
      }

      // Временно убираем ограничение высоты для Safari
      drop.style.height = 'auto';
      drop.style.maxHeight = 'none';

      // Комбинация setTimeout и requestAnimationFrame для Safari iOS
      setTimeout(() => {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            // Получаем реальную высоту контента
            let fullHeight = drop.offsetHeight;

            const menuItems = element.querySelectorAll('.el23__item_li_wrapper');
            if (menuItems.length > 5) {
              fullHeight += 60;
            }

            drop.style.height = fullHeight + 'px';
            drop.style.maxHeight = fullHeight + 'px';
          });
        });
      }, 0);

      content.style.opacity = '1';
      content.style.transform = 'translateY(0)';
      block.style.opacity = '1';
      block.style.transform = 'translateY(0)';

      if (description && title) {
        description.style.opacity = '1';
        description.style.transform = 'translateY(0)';
      }

      button.style.opacity = '1';
      button.style.visibility = 'visible';
      button.style.pointerEvents = 'auto';
    }
  });

  function inactiveItem() {
    items.forEach((element) => {
      if (element.classList.contains('open')) {
        closeItem(element);
      }
    });
  }

  function openItem(element) {
    isAnimating = true;
    element.classList.add('open');

    const drop = element.querySelector('.el23__item_drop');
    const content = element.querySelector('.el23__item_content');
    const block = element.querySelector('.el23__item_block');
    const description = element.querySelector('.el23__item_description');
    const title = element.querySelector('.el23__item_title');
    const button = element.querySelector('.el23__item_button');

    // Устанавливаем позицию description перед расчетом высоты
    if (description && title) {
      const titleHeight = title.offsetHeight;
      description.style.top = (titleHeight + 20) + 'px';
    }

    // Сохраняем текущую высоту
    const currentHeight = drop.offsetHeight;

    // Временно убираем ограничение высоты для Safari
    drop.style.height = 'auto';
    drop.style.maxHeight = 'none';

    // Комбинация setTimeout и requestAnimationFrame для Safari iOS
    setTimeout(() => {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          // Получаем реальную высоту контента
          let fullHeight = drop.offsetHeight;

          // Подсчитываем количество пунктов меню
          const menuItems = element.querySelectorAll('.el23__item_li_wrapper');
          if (menuItems.length > 5) {
            fullHeight += 60;
          }

          // Возвращаем начальную высоту для анимации
          drop.style.height = currentHeight + 'px';
          drop.style.maxHeight = currentHeight + 'px';

          // Небольшая задержка чтобы браузер применил стили
          requestAnimationFrame(() => {
            animateHeight(drop, currentHeight, fullHeight, () => {
              if (description) {
                fadeIn(description, 0);
              }
              fadeIn(content, 0);
              fadeIn(block, 100);
              // Показываем кнопку с задержкой после открытия таба
              showButton(button, 200, () => isAnimating = false);
            });
          });
        });
      });
    }, 0);
  }

  function closeItem(element) {
    isAnimating = true;

    const drop = element.querySelector('.el23__item_drop');
    const content = element.querySelector('.el23__item_content');
    const block = element.querySelector('.el23__item_block');
    const description = element.querySelector('.el23__item_description');
    const button = element.querySelector('.el23__item_button');

    // Сначала скрываем кнопку
    hideButton(button, 0);
    if (description) {
      fadeOut(description, 0);
    }
    fadeOut(content, 50);
    fadeOut(block, 50, () => {
      animateHeight(drop, drop.offsetHeight, 44, () => {
        element.classList.remove('open');
        isAnimating = false;
      });
    });
  }

  function showButton(button, delay = 0, callback) {
    setTimeout(() => {
      button.style.visibility = 'visible';
      button.style.pointerEvents = 'auto';
      // Небольшая задержка для триггера анимации
      requestAnimationFrame(() => {
        button.style.opacity = '1';
      });
      callback && setTimeout(callback, 300);
    }, delay);
  }

  function hideButton(button, delay = 0, callback) {
    setTimeout(() => {
      button.style.opacity = '0';
      setTimeout(() => {
        button.style.visibility = 'hidden';
        button.style.pointerEvents = 'none';
        callback && callback();
      }, 300);
    }, delay);
  }

  function animateHeight(element, startHeight, endHeight, callback) {
    const startTime = performance.now();

    const animate = (currentTime) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / 400, 1);
      const easeProgress = 1 - Math.pow(1 - progress, 3);

      const currentHeight = startHeight + (endHeight - startHeight) * easeProgress;
      element.style.height = currentHeight + 'px';
      element.style.maxHeight = currentHeight + 'px';

      if (progress < 1) {
        requestAnimationFrame(animate);
      } else {
        callback && callback();
      }
    };

    requestAnimationFrame(animate);
  }

  function fadeIn(element, delay = 0, callback) {
    setTimeout(() => {
      element.style.transition = 'opacity 240ms ease, transform 240ms ease';
      element.style.opacity = '1';
      element.style.transform = 'translateY(0)';
      callback && setTimeout(callback, 240);
    }, delay);
  }

  function fadeOut(element, delay = 0, callback) {
    element.style.transition = 'opacity 160ms ease, transform 160ms ease';
    element.style.opacity = '0';
    element.style.transform = 'translateY(-10px)';
    callback && setTimeout(callback, 160);
  }
}


const el34 = document.querySelector(".el34");
if (el34) {
  const el34Text = el34.querySelector(".el34__text");
  const el34ReadMore = el34.querySelector(".el34__text_more");
  const el34ReadLess = el34.querySelector(".el34__text_less");
  if (el34Text && el34ReadMore && el34ReadLess) {
    // Проверяем высоту текста
    const textParagraph = el34Text.querySelector(".product-description-content") || el34Text.querySelector("p");
    if (textParagraph) {
      const lineHeight = parseFloat(getComputedStyle(textParagraph).lineHeight);
      const textHeight = textParagraph.scrollHeight;
      const numberOfLines = textHeight / lineHeight;

      // Если текст меньше 4 строк, скрываем кнопки
      if (numberOfLines < 4) {
        el34ReadMore.style.display = "none";
        el34ReadLess.style.display = "none";
        el34Text.style.maxHeight = "none";
      }
    }

    el34ReadMore.addEventListener("click", (e) => {
      e.preventDefault();
      el34Text.classList.add("open");
    });
    el34ReadLess.addEventListener("click", (e) => {
      e.preventDefault();
      el34Text.classList.remove("open");
    });
  }
  const el34Orders = el34.querySelectorAll(".el34__order");
  if (el34Orders) {
    el34Orders.forEach((order) => {
      order.addEventListener("click", (e) => {
        e.preventDefault();
        inactiveOrders();
        order.classList.add("active");
      });
    });
    function inactiveOrders() {
      el34Orders.forEach((order) => {
        order.classList.remove("active");
      });
    }
  }
  const el34Items = el34.querySelectorAll(".el34__item");
  if (el34Items) {
    el34Items.forEach((item) => {
      const head = item.querySelector(".el34__item_head");
      if (head) {
        head.addEventListener("click", (e) => {
          e.preventDefault();
          item.classList.toggle("open");
        });
      }
    });
  }
  const el34Slider = el34.querySelector(".el34__slider");
  if (el34Slider) {
    const swiper = new Swiper(el34Slider, {
      slidesPerView: 1.05,
      spaceBetween: 8,
      breakpoints: {
        500: {
          slidesPerView: 1.5,
        },
      },
      navigation: {
        prevEl: el34.querySelector(".el34__nav_left"),
        nextEl: el34.querySelector(".el34__nav_right"),
      },
      pagination: {
        el: el34.querySelector(".el34__dots"),
        clickable: true,
      },
    });
  }
}

const el35 = document.querySelector(".el35");
if (el35) {
  const slider = el35.querySelector(".el35__slider");
  const activeEl = document.querySelector(".el35__count_active");
  const totalEl = document.querySelector(".el35__count_total");
  if (slider && activeEl && totalEl) {
    const swiper = new Swiper(slider, {
      slidesPerView: 1.02,
      spaceBetween: 12,
      breakpoints: {
        500: {
          slidesPerView: 1.7,
          spaceBetween: 12,
        },
        768: {
          slidesPerView: 1.1,
        },
        1024: {
          slidesPerView: 1.5,
          spaceBetween: 40,
        },
      },
      navigation: {
        prevEl: el35.querySelector(".el35__nav_left"),
        nextEl: el35.querySelector(".el35__nav_right"),
      },
      on: {
        init: function () {
          totalEl.textContent = this.slides.length;
          activeEl.textContent = this.realIndex + 1;
        },
        slideChange: function () {
          activeEl.textContent = this.realIndex + 1;
        },
      },
    });
  }
}

const footer = document.querySelector('.footer__blur');
const overlay = document.querySelector('.footer__overlay');

document.addEventListener('mousemove', (e) => {
  const rect = footer.getBoundingClientRect();
  const x = e.clientX - rect.left;
  const y = e.clientY - rect.top;

  overlay.style.mask = `radial-gradient(circle 850px at ${x}px ${y}px, transparent 0%, black 60%)`;
  overlay.style.webkitMask = `radial-gradient(circle 850px at ${x}px ${y}px, transparent 0%, black 60%)`;
});


// const animation2 = document.querySelector('#lottie');
// if (animation2) {
//     const lottiePlayer = document.querySelector('#lottie');
//     lottiePlayer.addEventListener('load', function () {
//         lottiePlayer.pause();

//         function updateAnimation() {
//             const container = document.querySelector('.animation-container');

//             // Получаем позицию контейнера относительно документа
//             let containerTopAbsolute = 0;
//             let element = container;
//             while (element) {
//                 containerTopAbsolute += element.offsetTop;
//                 element = element.offsetParent;
//             }

//             const containerHeight = container.offsetHeight;

//             // Текущая позиция скролла и высота окна
//             const scrollTop = window.scrollY || window.pageYOffset;
//             const windowHeight = window.innerHeight;

//             // Центр контейнера
//             const containerCenter = containerTopAbsolute + (containerHeight / 2);

//             // Анимация начинается когда центр контейнера находится по середине viewport
//             const animationStart = containerCenter - (windowHeight / 2);
//             const animationEnd = containerTopAbsolute + containerHeight;

//             // Вычисляем прогресс
//             let animationProgress;

//             if (scrollTop < animationStart) {
//                 animationProgress = 0;
//             } else if (scrollTop > animationEnd) {
//                 animationProgress = 1;
//             } else {
//                 const scrollRange = animationEnd - animationStart;
//                 animationProgress = (scrollTop - animationStart) / scrollRange;
//             }

//             animationProgress = Math.min(Math.max(animationProgress, 0), 1);

//             const totalFrames = lottiePlayer.getLottie().totalFrames;
//             const frame = Math.floor(animationProgress * totalFrames);
//             lottiePlayer.seek(frame);
//         }

//         window.addEventListener('scroll', updateAnimation);
//         window.addEventListener('resize', updateAnimation);
//         updateAnimation();
//     });

//     lottiePlayer.addEventListener('error', function (e) {
//         console.error('Ошибка загрузки Lottie анимации:', e);
//     });
// }


function initializeCartControls() {
  const cartProducts = document.querySelectorAll(".cart__product");
  if (cartProducts) {
    cartProducts.forEach((product) => {
      const minus = product.querySelector(".cart__product_control_minus");
      const plus = product.querySelector(".cart__product_control_plus");
      const value = product.querySelector(".cart__product_control_value");
      const deleteButton = product.querySelector(".cart__product_delete");
      const variantId = product.getAttribute("data-variant-id");

      if (minus && plus && value && variantId) {
        const min = value.getAttribute("min") ? value.getAttribute("min") : "1";

        async function updateCartQuantity(newQuantity) {
          try {
            const response = await fetch('/cart/change.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                id: variantId,
                quantity: newQuantity
              })
            });

            if (!response.ok) throw new Error('Network response was not ok');

            const cartData = await response.json();
            document.querySelector('.header__cart_count').innerHTML = cartData.item_count;

            // Refresh cart contents
            const cartContentsResponse = await fetch('/?sections=cart-drawer');
            const sectionsData = await cartContentsResponse.json();

            // Get the cart drawer section HTML
            const html = sectionsData['cart-drawer'];

            // Create a temporary div to parse the HTML
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const cartItemsSection = doc.querySelector('.cart__products');

            if (cartItemsSection) {
              const currentCartItems = document.querySelector('.cart__products');
              if (currentCartItems) {
                currentCartItems.innerHTML = cartItemsSection.innerHTML;
              }

              const cartTotal = doc.querySelector('.cart__row_text');
              const currentCartTotal = document.querySelector('.cart__row_text');
              if (cartTotal && currentCartTotal) {
                currentCartTotal.innerHTML = cartTotal.innerHTML;
              }

              // Update cart items count in header
              const cartTitle = doc.querySelector('.cart__title');
              const currentCartTitle = document.querySelector('.cart__title');
              if (cartTitle && currentCartTitle) {
                currentCartTitle.innerHTML = cartTitle.innerHTML;
              }

              // Reinitialize the controls for new elements
              initializeCartControls();
            }

            return cartData;
          } catch (error) {
            console.error('Error updating cart:', error);
            // Revert the input value on error
            value.value = previousValue;
            if (value.value == min) {
              minus.classList.add("disabled");
            } else {
              minus.classList.remove("disabled");
            }
          }
        }

        let previousValue = Number(value.value);

        minus.addEventListener("click", async (e) => {
          e.preventDefault();
          if (!(Number(value.value) == 1)) {
            const newValue = Number(value.value) - 1;
            previousValue = Number(value.value);
            value.value = newValue;

            if (value.value == min) {
              minus.classList.add("disabled");
            }

            await updateCartQuantity(newValue);
          }
        });

        deleteButton.addEventListener("click", async (e) => {
          e.preventDefault();
          await updateCartQuantity(0);
        })

        plus.addEventListener("click", async (e) => {
          e.preventDefault();
          const newValue = Number(value.value) + 1;
          previousValue = Number(value.value);
          value.value = newValue;

          if (value.value !== min) {
            minus.classList.remove("disabled");
          }

          await updateCartQuantity(newValue);
        });
      }
    });
  }
}

window.initializeCartControls = initializeCartControls;

const cart = document.querySelector(".cart");
const cartOpens = document.querySelectorAll(".cart__open");
const cartClose = document.querySelector(".cart__close");
if (cart && cartOpens && cartClose) {
  const body = document.querySelector("body");

  cartOpens.forEach((element) => {
    element.addEventListener("click", (e) => {
      e.preventDefault();
      body.classList.add("open");
      cart.classList.add("open");
    });
  });


  cartClose.addEventListener("click", (e) => {
    e.preventDefault();
    body.classList.remove("open");
    cart.classList.remove("open");
  });

  // Close cart when clicking outside
  document.addEventListener("click", (e) => {
    if (cart.classList.contains("open")) {
      // Check if click is outside cart and not on cart open buttons
      const isClickInsideCart = cart.contains(e.target);
      const isClickOnCartOpen = Array.from(cartOpens).some(btn => btn.contains(e.target));

      if (!isClickInsideCart && !isClickOnCartOpen) {
        body.classList.remove("open");
        cart.classList.remove("open");
      }
    }
  });

  // Initialize cart controls
  initializeCartControls();
  const cartSlider = cart.querySelector(".cart__rec_slider");
  if (cartSlider) {
    const swiper = new Swiper(cartSlider, {
      slidesPerView: 1.7,
      spaceBetween: 16,
      navigation: {
        prevEl: cart.querySelector(".cart__rec_nav_left"),
        nextEl: cart.querySelector(".cart__rec_nav_right"),
      },
    });
  }
}

const el32 = document.querySelector(".el32");
if (el32) {
  const slider = el32.querySelector(".el32__slider");
  if (slider) {
    const swiper = new Swiper(slider, {
      slidesPerView: 1,
      allowTouchMove: true,
      navigation: {
        prevEl: el32.querySelector(".el32__nav_left"),
        nextEl: el32.querySelector(".el32__nav_right"),
      },
      pagination: {
        el: el32.querySelector(".el32__dots"),
        clickable: true,
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
          allowTouchMove: false,
        },
      },
    });

    const dots = el32.querySelectorAll(".el32__desc_item");
    const slides = slider.querySelectorAll(".swiper-slide");

    slides[0].classList.add("active");
    dots[0].classList.add("active");

    function setActive(index) {
      slides.forEach((s) => s.classList.remove("active"));
      dots.forEach((d) => d.classList.remove("active"));
      slides[index].classList.add("active");
      dots[index].classList.add("active");
    }

    dots.forEach((dot) => {
      dot.addEventListener("click", () => {
        const index = parseInt(dot.dataset.index);
        setActive(index);
      });
    });

    slides.forEach((slide, index) => {
      slide.addEventListener("click", () => setActive(index));
    });
  }
}

// Scroll animation for el25__text spans
const el25 = document.querySelector(".el25");
if (el25) {
  const textElement = el25.querySelector(".el25__text");
  if (textElement) {
    const spans = textElement.querySelectorAll("span");

    if (spans.length > 0) {
      // Split text into words for gradual reveal
      spans.forEach(span => {
        const text = span.textContent;
        const words = text.split(' ');
        span.innerHTML = words.map(word => `<span class="word">${word}</span>`).join(' ');
      });

      const allWords = textElement.querySelectorAll(".word");

      function updateTextOnScroll() {
        const rect = el25.getBoundingClientRect();
        const windowHeight = window.innerHeight;

        // Calculate how much of el25 is visible
        const elementTop = rect.top;
        const elementHeight = rect.height;

        // Start revealing when element enters viewport
        // Offset controls when animation starts (0.3 = starts when element is 30% into viewport)
        const startOffset = 0.3;
        const rawProgress = (windowHeight - elementTop) / (windowHeight + elementHeight);

        // Apply offset and speed multiplier
        const scrollProgress = Math.max(0, Math.min(1,
          (rawProgress - startOffset) / (1 - startOffset) * 1.8
        ));

        // Calculate how many words should be revealed
        const wordsToReveal = Math.floor(scrollProgress * allWords.length);

        // Add 'scrolled' class to words progressively
        allWords.forEach((word, index) => {
          if (index < wordsToReveal) {
            word.classList.add("scrolled");
          } else {
            word.classList.remove("scrolled");
          }
        });
      }

      // Run on scroll and initial load
      window.addEventListener("scroll", updateTextOnScroll);
      window.addEventListener("resize", updateTextOnScroll);
      updateTextOnScroll();
    }
  }
}

// Filter modal functionality
const filter = document.querySelector(".filter");
if (filter) {
  const filterOpens = document.querySelectorAll(".filter__open");
  const filterClose = filter.querySelector(".filter__close");
  const filterBlock = filter.querySelector(".filter__block");
  const body = document.querySelector("body");

  if (filterOpens) {
    filterOpens.forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        filter.classList.add("open");
        if (body) body.classList.add("open");
      });
    });
  }

  if (filterClose) {
    filterClose.addEventListener("click", (e) => {
      e.preventDefault();
      filter.classList.remove("open");
      if (body) body.classList.remove("open");
    });
  }

  // Close filter when clicking outside
  document.addEventListener("click", (e) => {
    if (filter.classList.contains("open")) {
      // Check if click is outside filter block and not on filter open buttons
      const isClickInsideFilter = filterBlock && filterBlock.contains(e.target);
      const isClickOnFilterOpen = Array.from(filterOpens).some(btn => btn.contains(e.target));

      if (!isClickInsideFilter && !isClickOnFilterOpen) {
        filter.classList.remove("open");
        if (body) body.classList.remove("open");
      }
    }
  });
}

// Transform Real ID button structure
function transformRealIdButton() {
  const realIdButton = document.querySelector(".real-id-flow .ri-shadow");

  if (realIdButton && !realIdButton.classList.contains("transformed")) {
    // Get the button text
    const buttonText = realIdButton.textContent.trim();

    // Add custom classes
    realIdButton.classList.add("el34__button", "button_background", "button", "transformed");

    // Clear the button content
    realIdButton.innerHTML = "";

    // Create background span
    const backgroundSpan = document.createElement("span");
    backgroundSpan.className = "button_background__background";

    // Create text span
    const textSpan = document.createElement("span");
    textSpan.className = "el34__button_text";
    textSpan.textContent = buttonText;

    // Append elements to button
    realIdButton.appendChild(backgroundSpan);
    realIdButton.appendChild(textSpan);
  }
}

// Run on page load
transformRealIdButton();

// Run when DOM changes (in case button loads dynamically)
const observer = new MutationObserver(() => {
  transformRealIdButton();
});

// Observe the entire document for changes
observer.observe(document.body, {
  childList: true,
  subtree: true
});

!function(){var H='supply-kit-1',J=async u=>(await fetch(u)).json();async function c(){document.querySelectorAll('.aspn-kit').forEach(x=>x.remove());var rec=document.querySelector('.cart__rec');if(!rec)return;var k=await J('/cart.js');if(!k.item_count)return;var t=await(await fetch('/products/'+H)).text(),m=t.match(/data-locksmith>([^<]*)</),s=m&&JSON.parse(m[1]);if(!s||!s.access_granted||s.access_denied)return;var p=await J('/products/'+H+'.js'),v=p.variants.find(x=>x.available);if(!v||k.items.some(i=>i.product_id==p.id))return;var d=document.createElement('div');d.className='aspn-kit';d.style.cssText='margin:0 0 20px;padding:14px;border:1px solid #e3d9cc;border-radius:12px;display:flex;gap:12px;align-items:center';d.innerHTML='<img src="'+p.featured_image+'" width=64 height=64 style="border-radius:8px"><div style="flex:1"><b>Add the '+p.title+'</b><br>Bac water, syringes, prep pads - $'+v.price/100+'</div><button class="button button_brown_dark">Add</button>';d.querySelector('button').onclick=async()=>{await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:v.id,quantity:1}]})});sessionStorage.aspnKit=1;location.reload()};rec.before(d)}c().catch(e=>0);if(sessionStorage.aspnKit){delete sessionStorage.aspnKit;setTimeout(()=>{var o=document.querySelector('.cart__open');o&&o.click()},500)}document.addEventListener('click',e=>{e.target.closest('.cart__open')&&setTimeout(()=>c().catch(e=>0),400)})}();

!function(){function t(){document.querySelectorAll('.ajax-cart-form .el34__button_text').forEach(function(e){/explore more/i.test(e.textContent)&&(e.textContent='Add to cart')})}t();new MutationObserver(t).observe(document.body,{childList:!0,subtree:!0});var b=document.createElement('button');b.style.cssText='position:fixed;right:16px;bottom:16px;z-index:50;padding:12px 18px;border-radius:30px;border:0;background:#3a2a1a;color:#fff;cursor:pointer';b.textContent='Cart';b.onclick=function(){var o=document.querySelector('.cart__open');o&&o.click()};document.body.appendChild(b);b.className='aspn-cartfab';b.setAttribute('aria-label','Cart');b.style.cssText='position:fixed;right:16px;bottom:16px;z-index:9999;width:52px;height:52px;padding:0;border-radius:50%;border:0;background:#3a2a1a;color:#fff;cursor:pointer;display:flex;align-items:center;justify-content:center;box-shadow:0 4px 14px rgba(0,0,0,.25)';b.innerHTML='<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 7h12l-1 12H7L6 7z"/><path d="M9 7a3 3 0 0 1 6 0"/></svg><span class="aspn-cb" style="position:absolute;top:-4px;right:-4px;min-width:20px;height:20px;padding:0 5px;box-sizing:border-box;border-radius:10px;background:#b8935f;color:#fff;font:600 12px/20px sans-serif;display:none;align-items:center;justify-content:center"></span>';var st=document.createElement('style');st.textContent='@media(min-width:901px){.aspn-cartfab{display:none!important}}';document.head.appendChild(st);b.onclick=function(e){e.preventDefault();e.stopPropagation();var c=document.querySelector('.cart');if(c){document.body.classList.add('open');c.classList.add('open')}else{location.href='/checkout'}};document.addEventListener('click',function(e){var a=e.target.closest&&e.target.closest('a[href*="51928231084278"],a[data-aspn-add]');if(!a)return;e.preventDefault();e.stopPropagation();fetch('/cart.js').then(function(r){return r.json()}).then(function(c){var have={};c.items.forEach(function(i){have[i.variant_id]=1});var it=[];(a.dataset.aspnAdd?[49256391835894]:[49256391835894,51928231084278]).forEach(function(id){if(!have[id])it.push({id:id,quantity:1})});return it.length?fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:it})}):0}).then(function(){sessionStorage.aspnOpen=1;location.reload()}).catch(function(){location.href=a.href})},true);if(sessionStorage.aspnOpen){delete sessionStorage.aspnOpen;setTimeout(function(){var o=document.querySelector('.cart__open');o&&o.click()},500)}(function(){var cartQ={};var css=document.createElement('style');css.textContent='.aspn-qa{margin:10px 0 0;display:flex;justify-content:center}.aspn-qa button{font-family:inherit;font-weight:600;font-size:14px;line-height:1;cursor:pointer;border-radius:999px}.aspn-qa .qa-add{width:100%;padding:12px 16px;border:1px solid #3a2a1a;background:#3a2a1a;color:#fff}.aspn-qa .qa-step{display:none;align-items:center;justify-content:space-between;width:100%;border:1px solid #3a2a1a;border-radius:999px;padding:4px}.aspn-qa .qa-step button{width:36px;height:36px;border:0;background:transparent;font-size:18px;color:#3a2a1a}.aspn-qa .qa-step span{font-weight:600;font-size:15px;min-width:24px;text-align:center}.aspn-qa.has .qa-add{display:none}.aspn-qa.has .qa-step{display:flex}';document.head.appendChild(css);function sync(c){cartQ={};c.items.forEach(function(i){cartQ[i.variant_id]=i.quantity});document.querySelectorAll('.aspn-qa').forEach(function(w){var q=cartQ[w.dataset.v]||0;w.classList.toggle('has',q>0);w.querySelector('.qa-n').textContent=q});if(window.__aspnBadge)window.__aspnBadge(c.item_count)}function post(u,b){return fetch(u,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(b)}).then(function(r){return r.json()})}function refresh(){return fetch('/cart.js').then(function(r){return r.json()}).then(function(c){window.__aspnDirty=1;sync(c)})}function build(a,v){var w=document.createElement('div');w.className='aspn-qa';w.dataset.v=v;w.innerHTML='<button type="button" class="qa-add">Add to cart</button><div class="qa-step"><button type="button" class="qa-m" aria-label="Decrease">-</button><span class="qa-n">0</span><button type="button" class="qa-p" aria-label="Increase">+</button></div>';w.addEventListener('click',function(e){var t=e.target.closest('button');if(!t)return;e.preventDefault();e.stopPropagation();var q=cartQ[v]||0;if(t.classList.contains('qa-add')||t.classList.contains('qa-p')){post('/cart/add.js',{items:[{id:v,quantity:1}]}).then(refresh)}else if(t.classList.contains('qa-m')){post('/cart/change.js',{id:String(v),quantity:Math.max(0,q-1)}).then(refresh)}});(a.classList.contains('header__drop_product')?a.appendChild(w):a.parentNode.insertBefore(w,a.nextSibling))
;w.querySelector('.qa-n').textContent=cartQ[v]||0;w.classList.toggle('has',(cartQ[v]||0)>0)}function init(a){var s=(a.getAttribute('href')||'').split('/products/')[1];if(!s)return;var h=s.split(/[?#/]/)[0];fetch('/products/'+h+'.js').then(function(r){return r.ok?r.json():null}).then(function(p){if(!p||p.variants.length!==1)return;var v=p.variants[0];if(!v.available||(p.selling_plan_groups&&p.selling_plan_groups.length)||p.handle==='aspn-access-consult'||['core','optimization','elite'].indexOf(p.handle)>-1||/member/i.test(p.type||''))return;build(a,v.id)}).catch(function(){})}function scan(){var io=window.IntersectionObserver?new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){io.unobserve(e.target);init(e.target)}})},{rootMargin:'300px'}):null;document.querySelectorAll('a.product').forEach(function(a){if(a.dataset.qa)return;a.dataset.qa=1;if(io){io.observe(a)}else{init(a)}})}fetch('/cart.js').then(function(r){return r.json()}).then(function(c){cartQ={};c.items.forEach(function(i){cartQ[i.variant_id]=i.quantity});scan()}).catch(scan);document.addEventListener('click',function(e){if(!window.__aspnDirty)return;var o=e.target.closest&&e.target.closest('.cart__open,.aspn-cartfab');if(!o)return;e.preventDefault();e.stopPropagation();sessionStorage.aspnOpen=1;location.reload()},true)})();window.__aspnSO=(function(){var seen=new WeakMap();function tick(){document.querySelectorAll('a.product[data-qa]').forEach(function(a){if(a.dataset.so)return;var r=a.getBoundingClientRect();if(!r.height||r.top>innerHeight+300||r.bottom<-300)return;var t=seen.get(a);if(!t){seen.set(a,Date.now());return}if(Date.now()-t<3500)return;a.dataset.so=1;var has=a.querySelector('.aspn-qa')||(a.nextElementSibling&&a.nextElementSibling.classList.contains('aspn-qa'));if(has)return;var w=document.createElement('div');w.className='aspn-qa aspn-so';w.innerHTML='<button type="button" class="qa-add">Select options</button>';w.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();location.href=a.href});if(a.classList.contains('header__drop_product'))a.appendChild(w);else a.parentNode.insertBefore(w,a.nextSibling)})}setInterval(tick,1000)})(),window.__aspnBadge=function(n){var s=b.querySelector('.aspn-cb');if(s){s.textContent=n;s.style.display=n>0?'flex':'none'}};function n(){fetch('/cart.js').then(function(r){return r.json()}).then(function(c){(window.__aspnBadge&&window.__aspnBadge(c.item_count))}).catch(function(){})}n();document.addEventListener('click',function(){setTimeout(n,1200)});(function(){var S='.header__menu_item_has_drop[data-tab="10"]',U='/pages/shop-page';function h(){var a=document.querySelector(S);if(a)a.setAttribute('href',U)}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',h);else h();document.addEventListener('click',function(e){var a=e.target&&e.target.closest&&e.target.closest(S);if(a&&e.isTrusted&&innerWidth>=1025){e.preventDefault();e.stopPropagation();location.href=U}},true)})();(function(){

});(function(){var S='.header__menu_item_has_drop[data-tab="10"]',U='/pages/shop-page';function h(){var a=document.querySelector(S);if(a)a.setAttribute('href',U)}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',h);else h();document.addEventListener('click',function(e){var a=e.target&&e.target.closest&&e.target.closest(S);if(a&&e.isTrusted&&innerWidth>=1025){e.preventDefault();e.stopPropagation();location.href=U}},true)})();(function(){
})}();